import { mapActions, mapGetters } from 'vuex'
import moment from 'moment/src/moment'

const CONTRACT_STATE_ACTIVE = 'ACTIVE'
const CONTRACT_STATE_CANCELLED = 'CANCELLED'
const CONTRACT_STATE_TERMINATED = 'TERMINATED_BY_SYSTEM'
const CONTRACT_STATE_DISMISSED = 'DISMISSED_BY_CUSTOMER'

const CONTRACT_PAUSE_ACTIVE = 'ACTIVE'
const CONTRACT_PAUSE_CREATED = 'CREATED'

export default function customerContractState () {
  return {
    data () {
      return {
        loadedContractState: false,
        contractCancelled: false,
        contractTerminated: false,
        contractPauseActive: false,
        contractPauseCreated: false,
        contractPauseStartDate: null,
        contractPauseEndDate: null,
        forceContractPauseState: null,
        contractDismissedInFuture: false,
        dunningLevel: null,
        CONTRACT_STATE_ACTIVE: CONTRACT_STATE_ACTIVE,
        error: {}
      }
    },
    props: {
      forceContractState: {
        type: String,
        default: null
      }
    },
    created () {
      this.loadContractState({ forceUpdate: false }).then((result) => {
        this.processContractState()
      })
    },
    watch: {
      currentCustomerContract: {
        immediate: true,
        handler: function () {
          this.processContractState()
        }
      }
    },
    methods: {
      ...mapActions('contract', [
        'loadContractState'
      ]),
      processContractState () {
        if (this.currentCustomerContract !== null && this.currentCustomerContract.contract) {
          this.contractCancelled = (this.currentCustomerContract.contract.state !== CONTRACT_STATE_ACTIVE)
          this.contractTerminated = (this.currentCustomerContract.contract.state === CONTRACT_STATE_CANCELLED || this.currentCustomerContract.contract.state === CONTRACT_STATE_TERMINATED || this.currentCustomerContract.contract.state === CONTRACT_STATE_DISMISSED)

          this.contractPauseCreated = (this.currentCustomerContract.contract.pauseInformation?.bookedContractPauseInfo?.pauseStatus === CONTRACT_PAUSE_CREATED)
          this.contractPauseActive = (this.currentCustomerContract.contract.pauseInformation?.bookedContractPauseInfo?.pauseStatus === CONTRACT_PAUSE_ACTIVE)
          if (this.contractPauseCreated || this.contractPauseActive) {
            this.contractPauseStartDate = this.currentCustomerContract.contract.pauseInformation.bookedContractPauseInfo.startDate
            this.contractPauseEndDate = this.currentCustomerContract.contract.pauseInformation.bookedContractPauseInfo.endDate
          } else {
            this.contractPauseStartDate = null
            this.contractPauseEndDate = null
          }

          if (this.contractDismissal.contractDismissal === true && this.currentCustomerContract.contract.state === CONTRACT_STATE_ACTIVE) {
            this.contractDismissedInFuture = true
          } else {
            this.contractDismissedInFuture = false
          }

          this.dunningLevel = this.currentCustomerContract.dunningLevel || null

          this.loadedContractState = true
        }
      },
      reQueryContractState: async function () {
        this.loadContractState({ forceUpdate: true }).then((result) => {
          this.processContractState()
        })
      }
    },
    computed: {
      ...mapGetters('contract', ['currentCustomerContract', 'contractDismissal']),
      // when a customer has dismissed the contract, contains the date when the
      // dismissal is performed. otherwise null
      dismissalDate () {
        return this.contractDismissal?.pendingDismissal?.dismissalDate || null
      },
      formattedDismissalDate () {
        if (this.dismissalDate === null) {
          return ''
        }
        return moment(this.dismissalDate).format('DD.MM.YYYY')
      },
      formattedDismissalCancelableDate () {
        if (this.dismissalDate === null) {
          return ''
        }
        return moment(this.dismissalDate)
          .subtract(1, 'days')
          .format('DD.MM.YYYY')
      },
      // bool: does the customer has a pending dismissal
      hasPendingDismissal () {
        return this.dismissalDate !== null && this.contractDismissal?.contractDismissal === true && this.currentCustomerContract?.contract?.state === CONTRACT_STATE_ACTIVE
      },
      isContractDismisseld () {
        return this.contractDismissal?.contractDismissal === true && this.currentCustomerContract?.contract?.state !== CONTRACT_STATE_ACTIVE
      },
      isSimCardLocked: function () {
        return this.currentCustomerContract?.contract?.simCard?.status === 'PASSIVATED'
      },
      hasDunningLevel () {
        return this.dunningLevel > 0
      },
      contractState: function () {
        return {
          contractTerminated: this.contractTerminated,
          contractCancelled: this.contractCancelled,
          formattedDismissalDate: this.formattedDismissalDate,
          hasPendingDismissal: this.hasPendingDismissal,
          loadedContractState: this.loadedContractState,
          currentCustomerContract: this.currentCustomerContract,
          contractPauseActive: this.contractPauseActive
        }
      }
    }
  }
}
